import { useMutation } from "@tanstack/react-query";
import type { UseMutationResult } from "@tanstack/react-query";

import { API_ROUTES } from "../../api/ApiRoutes";
import type {
  AffiliateContractUploadData,
  AffiliateContractUploadRequest,
  ApiSuccessEnvelope,
} from "../../types/affiliates";
import { getPrivateInstance } from "../_privateInstance";

const postAffiliateContractUploadUrl = async (
  payload: AffiliateContractUploadRequest,
): Promise<AffiliateContractUploadData> => {
  const response = await getPrivateInstance().post<
    ApiSuccessEnvelope<AffiliateContractUploadData>
  >(API_ROUTES.AFFILIATE_CONTRACT_UPLOAD_URL, payload);
  return response.data.data;
};

export const useAffiliateContractUploadUrl = (): UseMutationResult<
  AffiliateContractUploadData,
  Error,
  AffiliateContractUploadRequest
> =>
  useMutation({
    mutationKey: ["affiliates", "contract-upload-url"],
    mutationFn: postAffiliateContractUploadUrl,
  });
